import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonImg } from '@ionic/vue';
    import { computed, ref, useAttrs } from 'vue';
    import { useGeneralStore } from '@/store/general';

    const defaultImage = 'assets/vectors/blank.svg';

export default /*@__PURE__*/_defineComponent({
  __name: 'BaseImage',
  props: {
        src: {
            type: String,
            required: false,
        },
    },
  setup(__props) {

    

    const generalStore = useGeneralStore();

    const getImagesAddress = computed(() => generalStore.getImagesAddress);
    const imageFailsToLoad = ref(false);
    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonImg), _mergeProps(useAttrs(), {
    src: !imageFailsToLoad.value && !!__props.src ? `${getImagesAddress.value}/${__props.src}` : defaultImage,
    onIonError: _cache[0] || (_cache[0] = ($event: any) => (imageFailsToLoad.value = true))
  }), null, 16, ["src"]))
}
}

})